/**
 * ZendeskLogo/index.js
 * desc: Zendesk logo
 * note: renders an accessible button (aria-label) when given an onClick handler; otherwise a static figure
 */
'use strict';

import IconButton from '../IconButton';
import './styles.css';


const ZendeskLogo = (props) => (
    <IconButton baseClassName="zendesk logo" label="Zendesk" tooltip={ null } { ...props }>
        <svg viewBox="0 0 24 19" xmlns="http://www.w3.org/2000/svg"><path d="M11.085 4.804v13.383H0L11.085 4.804z" /><path d="M11.085 0A5.542 5.542 0 110 0h11.085z" /><path d="M12.914 18.187a5.542 5.542 0 1111.085 0H12.914z" /><path d="M12.914 13.383V0H24L12.914 13.383z" /></svg>
    </IconButton>
);


export default ZendeskLogo;
